module.exports = __webpack_public_path__ + "static/media/tk.1959d9de.svg";